// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__JIwh8","label":"Completed_label__KP0Pg"};